import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import theme from './theme/theme';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import DashboardLayout from './components/layout/DashboardLayout';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import DocumentUpload from './pages/auth/DocumentUpload';
import VerificationPending from './pages/auth/VerificationPending';

// Dashboard Pages
import Dashboard from './pages/dashboard/Dashboard';
import Partners from './pages/partners/Partners';
import ServiceRequests from './pages/services/ServiceRequests';
import Earnings from './pages/earnings/Earnings';
import Reviews from './pages/reviews/Reviews';
import Contracts from './pages/contracts/Contracts';
import Manager from './pages/manager/Manager';

// Placeholder components for other pages
const Profile = () => <div>Profile Page - Coming Soon</div>;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/document-upload" element={<DocumentUpload />} />
            <Route path="/verification-pending" element={<VerificationPending />} />

            {/* Protected Routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="partners" element={<Partners />} />
              <Route path="service-requests" element={<ServiceRequests />} />
              <Route path="earnings" element={<Earnings />} />
              <Route path="reviews" element={<Reviews />} />
              <Route path="contracts" element={<Contracts />} />
              <Route path="manager" element={<Manager />} />
              <Route path="profile" element={<Profile />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
